import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { OfflineBanner } from "@/components/OfflineBanner";
import { PlanRenewalBanner } from "@/components/PlanRenewalBanner";
import { PlanLimitUpsell } from "@/components/PlanLimitUpsell";
import { MobileBottomNav } from "@/components/MobileBottomNav";
import { CommandPalette } from "@/components/CommandPalette";
import BranchGate from "@/components/BranchGate";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div
                data-testid="auth-loading"
                className="min-h-screen flex items-center justify-center vt-pattern"
            >
                <div className="text-[#1B5E20] font-medium">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
    // Branch picker is the very first post-OTP gate — wraps privacy-onboarding
    // too, so a new user picks their community before anything else.
    const inner = (() => {
        if (!user.privacy_onboarded && location.pathname !== "/privacy-onboarding") {
            return <Navigate to="/privacy-onboarding" replace />;
        }
        return (
            <>
                <PlanRenewalBanner />
                <OfflineBanner />
                {children}
                <MobileBottomNav />
                <CommandPalette />
                <PlanLimitUpsell />
            </>
        );
    })();
    return <BranchGate>{inner}</BranchGate>;
}
